import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Card, Input, Button } from '../../components/ui';
import { AlertTriangle, TrendingUp, Users, ArrowRight } from 'lucide-react';
import { cn } from '../../lib/utils';

export function AlumniMentorshipMatcherTool() {
  const [mentees, setMentees] = useState('50');
  const [ratio, setRatio] = useState('2');
  const [availableMentors, setAvailableMentors] = useState('20');

  const mCount = parseInt(mentees) || 0;
  const r = parseFloat(ratio) || 1;
  const available = parseInt(availableMentors) || 0;

  const requiredMentors = Math.ceil(mCount / r);
  const shortfall = Math.max(0, requiredMentors - available);
  const matchedMentees = Math.min(mCount, available * r);
  const waitlist = Math.max(0, mCount - matchedMentees);

  return (
    <div className="grid lg:grid-cols-2 gap-8 text-left">
      <div className="space-y-6">
        <Card className="p-6 space-y-4">
          <h3 className="text-lg font-bold">Mentorship Parameters</h3>
          <div>
            <label className="text-[10px] uppercase font-bold text-gray-400">Total Mentees (Graduates)</label>
            <Input type="number" value={mentees} onChange={e => setMentees(e.target.value)} />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="text-[10px] uppercase font-bold text-gray-400">Target Ratio (Mentees/Mentor)</label>
              <Input type="number" value={ratio} onChange={e => setRatio(e.target.value)} />
            </div>
            <div>
              <label className="text-[10px] uppercase font-bold text-gray-400">Available Mentors</label>
              <Input type="number" value={availableMentors} onChange={e => setAvailableMentors(e.target.value)} />
            </div>
          </div>
        </Card>
      </div>

      <div className="space-y-4">
         <Card className="p-6 bg-amber-50 border-amber-100 dark:bg-amber-900/20 dark:border-amber-800">
            <span className="text-[10px] uppercase font-bold text-amber-600 block mb-1">Required Mentors</span>
            <p className="text-4xl font-black text-amber-700">{requiredMentors}</p>
         </Card>
         <Card className={`p-6 ${shortfall > 0 ? 'bg-red-50 border-red-100 dark:bg-red-900/20 dark:border-red-800' : 'bg-green-50 border-green-100 dark:bg-green-900/20 dark:border-green-800'}`}>
            <span className={`text-[10px] uppercase font-bold block mb-1 ${shortfall > 0 ? 'text-red-600' : 'text-green-600'}`}>
              Waitlist / Shortfall
            </span>
            <p className={`text-4xl font-black ${shortfall > 0 ? 'text-red-700' : 'text-green-700'}`}>
              {waitlist} <span className="text-sm font-bold uppercase tracking-wider opacity-60">Mentees unassigned</span>
            </p>
         </Card>

         <div className="p-4 bg-[#FFD600] text-black border-2 border-black space-y-2">
           <p className="text-xs font-bold leading-snug">
             Want to automate alumni matching and mentor rosters? Centralize alumni chapters and track career connections in one place.
           </p>
           <Link
             to="/sign-up"
             className="inline-flex items-center gap-1.5 text-xs font-black uppercase tracking-wider bg-black text-white hover:bg-[#0044FF] px-3 py-1.5 transition-colors cursor-pointer"
           >
             Create Free Organization <ArrowRight className="w-3.5 h-3.5" />
           </Link>
         </div>
      </div>
    </div>
  );
}

